import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSignalPerfect, faPowerOff, faXmark, faCheck, faCheckDouble, faCalendarAlt, faSpinner, faPaperPlane, faClock, faBan,
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSignalPerfect, faPowerOff, faXmark, faCheck, faCheckDouble, faCalendarAlt, faSpinner, faPaperPlane, faClock, faBan)
Vue.component('font-awesome-icon', FontAwesomeIcon)
